import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_themed_image = _resolveComponent("themed-image")

  return ($props.src)
    ? (_openBlock(), _createBlock(_component_base_image, _mergeProps({ key: 0 }, _ctx.$attrs, {
        src: $props.src,
        alt: $props.alt
      }), null, 16 /* FULL_PROPS */, ["src", "alt"]))
    : (_openBlock(), _createBlock(_component_themed_image, _mergeProps({ key: 1 }, _ctx.$attrs, {
        src: _ctx.placeholderSrc,
        alt: $props.alt
      }), null, 16 /* FULL_PROPS */, ["src", "alt"]))
}